<template>
  <div class="app-container">
    <!--筛选组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="name">
          <el-input
            v-model="listQuery.name"
            placeholder="请输入表单名称"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
          >搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <el-button
          v-auth="'Form.create'"
          class="action-item"
          type="primary"
          icon="el-icon-edit"
          @click="HandleCreate"
        >
          添加
        </el-button>
        <el-button
          v-auth="'Form.delete'"
          class="action-item"
          icon="el-icon-delete"
          @click="BatchDelete"
        >删除
        </el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <!--列开始-->
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        type="index"
        label="序号"
        width="55"
        :index="indexMethod"
        align="center"
      />
      <el-table-column
        align="center"
        prop="name"
        label="表单名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="table_name"
        label="数据表名"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="desc"
        label="介绍"
      ></el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == 0" type="success">已启用</el-tag>
          <el-tag v-else type="danger">已禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="create_time"
        width="180"
        label="添加时间"
        sortable
      ></el-table-column>
      <el-table-column
        align="center"
        prop=""
        label="操作"
        width="200"
        class-name="action"
      >
        <template slot-scope="scopes">
          <el-button
            v-auth="'Form.edit'"
            type="text"
            plain
            icon="el-icon-edit"
            size="mini"
            @click="HandleUpdate(scopes.row)"
          >
            编辑
          </el-button>
          <el-button
            v-auth="'Form.delete'"
            type="text"
            plain
            icon="el-icon-delete"
            size="mini"
            @click="RowDelete(scopes.row)"
          >
            删除
          </el-button>
          <router-link
            v-auth="'Form.field'"
            :to="'/form/field?form_id=' + scopes.row.id"
          >
            <el-button
              v-auth="'Form.field'"
              type="text"
              plain
              icon="el-icon-edit"
              size="mini"
            >
              管理字段
            </el-button>
          </router-link>
          <el-button
            v-auth="'Form.preview'"
            type="text"
            plain
            icon="el-icon-view"
            size="mini"
            @click="Preview(scopes.row)"
          >
            预览表单
          </el-button>
          <router-link
            v-auth="'Form.find'"
            :to="'/form/records?form_id=' + scopes.row.id"
          >
            <el-button
              v-auth="'Form.find'"
              type="text"
              plain
              icon="el-icon-view"
              size="mini"
            >
              查看填写记录
            </el-button>
          </router-link>
          <el-button
            v-auth="'Form.clone'"
            type="text"
            plain
            icon="el-icon-copy-document"
            size="mini"
            @click="cloneForm(scopes.row)"
          >
            克隆表单
          </el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />

    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="100px"
        style="width: 400px; margin-left:50px;"
      >
        <el-form-item label="表单名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <!--        <el-form-item label="数据表名称" prop="table_name">-->
        <!--          <el-input v-model="temp.table_name" :readonly="dialogStatus=='update'" />-->
        <!--        </el-form-item>-->
        <el-form-item label="介绍" prop="desc">
          <el-input
            v-model="temp.desc"
            type="textarea"
            autosize
            placeholder="请输入介绍"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="temp.status">
            <el-radio-button label="0">启用</el-radio-button>
            <el-radio-button label="1">禁用</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>

    <!-- 预览表单 -->
    <el-dialog title="预览表单" :visible.sync="isPreview">
      <el-form
        ref="previewForm"
        :rules="previewRules"
        :model="previewSubData"
        label-position="left"
        label-width="100px"
        style="width: 700px; margin-left:50px;"
      >
        <el-form-item
          v-for="(item, index) in previewData"
          :key="index"
          :label="item.name"
          :prop="item.field"
        >
          <!-- JSON -->
          <template v-if="item.formtype == 'json'">
            <el-input
              v-model="previewSubData[item.field]"
              type="textarea"
              :width="item.setting.width"
              :height="item.setting.height"
              :placeholder="item.tips"
            />
          </template>
          <!-- 单行文本 -->
          <template v-if="item.formtype == 'text'">
            <el-input
              v-model="previewSubData[item.field]"
              :placeholder="item.tips"
            />
          </template>
          <!-- 多行文本 -->
          <template v-if="item.formtype == 'textarea'">
            <el-input
              v-model="previewSubData[item.field]"
              type="textarea"
              :width="item.setting.width"
              :height="item.setting.height"
              :placeholder="item.tips"
            />
          </template>
          <!-- 编辑器 -->
          <template v-if="item.formtype == 'editor'">
            <el-col>
              <WangEditor
                v-model="previewSubData[item.field]"
                :value.sync="previewSubData[item.field]"
              />
            </el-col>
          </template>
          <!-- 单选 -->
          <template
            v-if="item.formtype == 'box' && item.setting.boxtype == 'radio'"
          >
            <el-radio
              v-for="(option, optionKey) in item.setting.options"
              :key="optionKey"
              v-model="previewSubData[item.field]"
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </template>
          <!-- 下拉 -->
          <template
            v-if="item.formtype == 'box' && item.setting.boxtype == 'select'"
          >
            <el-select
              v-model="previewSubData[item.field]"
              :placeholder="item.tips"
            >
              <el-option
                v-for="(option, optionKey) in item.setting.options"
                :key="optionKey"
                :label="option.value"
                :value="option.value"
              ></el-option>
            </el-select>
          </template>
          <!-- 复选 -->
          <template
            v-if="item.formtype == 'box' && item.setting.boxtype == 'checkbox'"
          >
            <el-checkbox-group v-model="previewSubData[item.field]">
              <el-checkbox
                v-for="(option, optionKey) in item.setting.options"
                :key="optionKey"
                v-model="previewSubData[item.field]"
                :label="option.value"
              >{{ option.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <!-- 单图 -->
          <template v-if="item.formtype == 'image'">
            <FileList
              v-model="previewSubData[item.field]"
              :item-width="item.setting.images_width"
              :item-height="item.setting.images_height"
              :limit="1"
              type="image"
            />
          </template>
          <!-- 多图 -->
          <template v-if="item.formtype == 'images'">
            <FileList
              v-model="previewSubData[item.field]"
              :item-width="item.setting.images_width"
              :item-height="item.setting.images_height"
              :limit="item.setting.upload_number"
              type="image"
            />
          </template>
          <!-- 单文件 -->
          <template v-if="item.formtype == 'file'">
            <FileList
              v-model="previewSubData[item.field]"
              :limit="1"
              type="document"
            />
          </template>
          <!-- 单文件 -->
          <template v-if="item.formtype == 'files'">
            <FileList
              v-model="previewSubData[item.field]"
              :limit="item.setting.upload_number"
              type="document"
            />
          </template>
          <!-- 数字 -->
          <template v-if="item.formtype == 'number'">
            <el-input-number
              v-model="previewSubData[item.field]"
              :min="item.setting.min"
              :max="item.setting.max"
            ></el-input-number>
          </template>
          <!-- 小数 -->
          <template v-if="item.formtype == 'decimal'">
            <el-input-number
              v-model="previewSubData[item.field]"
              :precision="item.setting.decimaldigits"
              :min="item.setting.min"
              :max="item.setting.max"
            ></el-input-number>
          </template>
          <!-- 日期（2023-04-13） -->
          <template v-if="item.formtype == 'date'">
            <el-date-picker
              v-model="previewSubData[item.field]"
              type="date"
              :placeholder="item.tips"
            ></el-date-picker>
          </template>
          <!-- 日期（2023-04-13 12:01:01） -->
          <template v-if="item.formtype == 'datetime'">
            <el-date-picker
              v-model="previewSubData[item.field]"
              type="datetime"
              :placeholder="item.tips"
            ></el-date-picker>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isPreview = false">取消</el-button>
        <!-- <el-button type="primary" @click="ConfirmFormData">保存</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import api from '@/api/examination/form' // 和数据交互相关写在api 方便复用
// import records from '@/api/examination/records' // 和数据交互相关写在api 方便复用
import field from '@/api/examination/field' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import FileList from '@/components/attachment/FileList'
import WangEditor from '@/components/WangEditor'

const api = {}
const records = {}

export default {
  name: 'Form',
  components: { Pagination, WangEditor, FileList },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      field,
      records,
      // 校验
      rules: {
        name: [
          {
            required: true,
            message: '请输入表单名称',
            trigger: ['blur', 'change']
          }
        ]
        // 'table_name': [
        //   { required: true, message: '请输入数据表名', trigger: ['blur', 'change'] },
        //   { pattern: /[a-zA-z]$/, message: '只允许设置字母' }
        // ]
      },

      temp: {},
      // 是否显示预览表单弹框
      isPreview: false,
      // 表单模型字段数据集
      previewData: {},
      // 表单提交绑定值
      previewSubData: {},
      // 表单模型必填集
      previewRules: {}
    }
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
  },
  methods: {
    resetTemp() {
      this.temp = {
        id: undefined,
        status: 0
      }
    },
    // 提交添加
    ConfirmFormData() {
      this.$refs['previewForm'].validate(valid => {
        if (valid) {
          this.records.WriteForm(this.previewSubData).then(response => {
            this.isPreview = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    Preview(row) {
      this.isPreview = true
      this.field.Preview({ form_id: row.id }).then(response => {
        this.previewData = response.data.data
        this.previewSubData = response.data.subData
        this.previewSubData.form_id = row.id
        this.previewRules = response.data.rules
      })
    },
    // 行删除
    RowDelete(row) {
      var ids = [row[this.primary_key]]
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$confirm('确定要删除吗,删除后所有关联数据将无法恢复', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.api.Delete(ids).then(response => {
                this.$message({ message: '操作成功', type: 'success' })
                this.SearchData() // 重新加载数据
              })
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 克隆表单
    cloneForm(row) {
      this.$confirm('确定要克隆数据吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api.cloneForm({ id: row.id }).then(response => {
            this.$message({ message: '操作成功', type: 'success' })
            this.SearchData() // 重新加载数据
          })
        })
        .catch(() => {})
    }
  }
}
</script>
